<template>
  <div>
    <van-dialog
      v-model="showDialog"
      title="请输入以下信息，核实潜水员身份"
      confirm-button-text="验证潜水员身份"
      cancel-button-text="取消"
      :before-close="beforeClose"
      show-cancel-button
      show-confirm-button
      @confirm="onConfirm"
    >
      <div class="inputRect">
        <van-row>
          <van-col span="6" class="rigth">英文姓</van-col>
          <van-col span="18">
            <van-field v-model="formData.lastName" :disabled="buttonLoading" required placeholder="例如zhang" />
          </van-col>
        </van-row>
        <van-row>
          <van-col span="6" class="rigth">英文名</van-col>
          <van-col span="18">  <van-field v-model="formData.firstName" :disabled="buttonLoading" required placeholder="例如san feng" /></van-col>
        </van-row>
        <van-row>
          <van-col span="6" class="rigth">生日</van-col>
          <van-col span="18">  <van-field v-model="formData.birthday" :disabled="buttonLoading" required placeholder="请选择出生日期" @click="onShowBirthday" /></van-col>
        </van-row>
        <van-row>
          <van-col span="6" class="rigth">邮箱</van-col>
          <van-col span="18">  <van-field v-model="formData.email" :disabled="buttonLoading" placeholder="电子邮箱" /></van-col>
        </van-row>
      </div>
    </van-dialog>
    <dateSelect v-model="showBirthday" @onChange="onBirthdayChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Dialog, Field, Toast } from 'vant'
import dateSelect from '@/components/dateSelect'
import { checkUserLastName, MyNotify } from '@/utils/base'
// import { GetSelfUrl } from '@/utils/request'
// import router from '@/router'

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    [Toast.name]: Toast,
    dateSelect
  },
  props: {
    // eslint-disable-next-line
    value: Boolean,
    // eslint-disable-next-line
    url:String,
  },
  data() {
    return {
      showBirthday: false,
      showDialog: false,
      buttonLoading: false,
      dialogDone: undefined,
      formData: {
        lastName: '',
        firstName: '',
        birthday: '',
        email: '',
        url: ''
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showDialog = true
      }
    },
    url(newValue) {
      this.formData.url = newValue
      console.log('certificateDialog.Url', newValue)
    }

  },
  created() {

  },
  methods: {
    beforeClose(action, done) {
      if (this.buttonLoading) {
        done(false)
        return
      }
      if (action === 'cancel') {
        this.$emit('input', false)
        done()
        return
      }
      this.dialogDone = done
      //   this.buttonLoading = true
      //   console.log('beforeClose', this.buttonLoading)
      done(false)
    },
    onConfirm() {
      if (this.buttonLoading) {
        return
      }
      if (this.formData.lastName.length < 1) {
        MyNotify('error', '例如zhang')
        return
      }
      if (this.formData.firstName.length < 1) {
        MyNotify('error', '例如san feng')
        return
      }
      if (this.formData.birthday.length < 1) {
        MyNotify('error', '请选择生日')
        return
      }
      let EmailStr = ''
      if (this.formData.email.length > 0) {
        EmailStr = '\n邮箱:' + this.formData.email
      }
      checkUserLastName(this.formData.firstName, () => {
        Dialog.confirm({
          title: '核对姓名',
          message: '请核对您的英文姓:' + this.formData.lastName + '\n名:' + this.formData.firstName + '\n生日:' + this.formData.birthday + EmailStr + '\n是否正确,一旦提交无法修改!'
        }).then(() => {
          this.onPostData()
        })
      })
    },
    onBirthdayChange(date) {
      console.log('selectDate', date)
      this.formData.birthday = date
    },
    onShowBirthday() {
      if (this.buttonLoading) {
        return
      }
      this.showBirthday = true
    },

    onPostData() {
      this.buttonLoading = true
      request({
        url: '/user/updateUserNameBirthday',
        method: 'post',
        data: this.formData
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (response.data) {
          Dialog.alert({
            title: '提交失败',
            message: response.data
          }).then(() => {
          })
          return
        }
        this.onWait()
      })
    },
    onWait() {
      this.waitTime = 180
      this.toastLoading = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '目前核实身份人数较多，核实成功后将以公众号消息通知您参与活动,预计' + this.waitTime + '秒!'
      })
      this.waitTimer = setInterval(() => {
        this.waitTime--
        if (this.waitTime > 0 && this.waitTime < 160) {
          this.toastLoading.message = '目前核实身份人数较多，您可以关闭页面，核实成功后，将以公众号通知形式邀请您参与活动[' + this.waitTime + '秒]!'
          if (this.waitTime % 10 === 0) {
            this.onCheckFinish()
          }
        } else if (this.waitTime > 0) {
          this.toastLoading.message = '目前核实身份人数较多，核实成功后将以公众号消息通知您参与活动,预计' + this.waitTime + '秒!'
          if (this.waitTime % 10 === 0) {
            this.onCheckFinish()
          }
        } else {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.confirm({
            title: '未能完成检查',
            message: '非常抱歉，我们尚未能完成对您资质证书的检查，稍后查询完成我们将会给你发送推送通知，您是否现在继续等待?'
          }).then(() => {
            this.onWait()
          })
        }
      }, 1000)
    },
    onCheckFinish() {
      request({
        url: '/user/getUserHaveCertificate',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        if (response.data.have) {
          clearInterval(this.waitTimer)
          Toast.clear()
          if (this.dialogDone) {
            this.dialogDone()
          }
          this.$emit('input', false)
          this.$emit('finish')
        } else if (response.data.finish) {
          clearInterval(this.waitTimer)
          Toast.clear()
          Dialog.alert({
            title: '未查询到您的潜水资质',
            message: '未能查询到您拥有潜水员资质，请检查您输入的英文(拼音)姓名、出生日期、邮箱是否正确。'
          }).then(() => {

          })
        }
      })
    }
  }
}
</script>

<style scoped>
.rigth{
    line-height: 44px;
}
.inputRect{
    margin-top: 1em;
}
</style>
